import { z } from 'zod'

export const CardFieldDefinition = z.object({
  name: z.string(),
  legalValues: z.union([
    z.object({
      type: z.union([z.literal('integer'), z.literal('decimal')]),
      range: z.tuple([z.number(), z.number()]).optional(),
    }),
    z.object({ type: z.literal('enum'), options: z.string().array().optional() }),
  ]),
  description: z.string(),
  purpose: z.string(),
})

export type CardFieldDefinition = z.infer<typeof CardFieldDefinition>

export const CardDefinition = z.object({
  cardName: z.string(),
  cardPurpose: z.string(),
  cardSet: z.string(),
  fields: CardFieldDefinition.array(),
})

export type CardDefinition = z.infer<typeof CardDefinition>
